<template>
  <div>
    <ItemPage
      title="Sistema de ensino"
      size="md"
      :actions="actions"
    >
      <template v-if="teachingSystemsView">
        <v-form
          ref="form"
        >
          <v-container>
            <v-row>
              <v-col
                cols="6"
                class="mr-auto"
              >
                <v-text-field
                  v-model="teachingSystem.name"
                  :rules="rulesName"
                  :disabled="!teachingSystemsUpdate"
                  label="Nome"
                  @input="checkUpdate"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="teachingSystem.short_name"
                  :disabled="!teachingSystemsUpdate"
                  :rules="[() => (sizes(teachingSystem.name) < 20 || sizes(teachingSystem.short_name) > 1) || 'Nome maior que 20 caracteres, inclua sigla(min. 2 caracteres)', () => (teachingSystem.short_name === null || teachingSystem.short_name === '' || sizes(teachingSystem.short_name) <21 && sizes(teachingSystem.short_name) > 1 ) || 'inclua sigla(min. 2, max 20 caracteres)']"
                  :error-messages="formError.short_name"
                  :counter="20"
                  maxlength="20"
                  label="Abreviatura"
                  @input="checkUpdate"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>

      <template v-else>
        usuário sem permissão
      </template>
    </ItemPage>
    <ItemPage
      title="Segmentos"
      size="md"
      :backbtn="false"
      :actions="actionsVolumes"
    >
      <template
        v-if="volumesView"
      >
        <v-simple-table fixed-header>
          <template v-if="loading">
            <Load :loadingmsg="loadingMsgvolumes" />
          </template>
          <div
            v-else
            class="mr-5 ml-5"
          >
            <v-data-table
              :headers="headersvolumes"
              :items="gradeLevelGroups"
              :items-per-page="15"
              item-key="id"
            >
              <!-- eslint-disable-next-line -->
              <!-- <template v-slot:item.deleteItem="{ item }">
                <v-btn
                  icon
                  @click="confirmDelete(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template> -->
            </v-data-table>
          </div>
        </v-simple-table>
      </template>
      <template v-else>
        usuário sem permissão
      </template>
    </ItemPage>
  </div>
</template>

<script>
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'
import Load from '@/components/Loading.vue'
import AddGradeLevelAndVolumeDialog from '@/components/settings/AddGradeLevelAndVolumeDialog.vue'

export default {
  components: {
    ItemPage,
    Load
  },
  data () {
    return {
      volumesView: false,
      volumesCreate: false,
      contentsvolumes: [],
      gradeLevelGroups: [],
      loadingMsgvolumes: '',
      headersvolumes: [
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        }
      ],

      dialogConfirm: false,
      btnDisable: true,
      renderComponent: 0,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.',
        value => (value && value.length >= 3) || 'Min 3 caracteres'
      ],
      dialogAddGradeLevel: false,
      loading: false,
      loadingSave: false,
      update: false,
      request: false,
      currentTeachingSystem: {},
      teachingSystem: {},
      gradeLevels: [],
      formError: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },

    actions () {
      return [
        {
          label: 'Atualizar',
          action: this.updateTeachingSystem,
          icon: 'mdi-floppy',
          disabled: this.btnDisable
        },
        {
          label: 'Deletar',
          action: this.deleteTeachingSystem,
          icon: 'mdi-delete',
          disabled: !this.teachingSystemsDelete
        }
      ]
    },
    actionsVolumes () {
      return [
        {
          label: 'Adicionar segmento',
          action: this.openAddVolume,
          icon: 'mdi-plus',
          disabled: !this.volumesCreate
        }
      ]
    }
  },
  created () {
    this.teachingSystemsUpdate = utils.checkPermissions('teaching-systems.update-any')
    this.teachingSystemsView = utils.checkPermissions('teaching-systems.view-any')
    this.teachingSystemsDelete = utils.checkPermissions('teaching-systems.delete')
    this.volumesView = utils.checkPermissions('volumes.view-any')
    this.volumesCreate = utils.checkPermissions('volumes.create')
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      await this.getTeachingSystem()
      await this.getGradeLevelGroup()
    },

    async openAddVolume () {
      this.$dialog.custom(AddGradeLevelAndVolumeDialog).show()
        .then(async (response) => {
          if (!response) {
            return
          }
          const data = {
            volume_id: response.volume_id
          }
          await this.$api.addVolumeByTeachingSystemAndGradeLevel(this.id, response.grade_level_id, data)
          this.getGradeLevelGroup()
        })
    },
    async getGradeLevelGroup () {
      this.loading = true
      this.loadingMsgvolumes = 'Carregando lista dos seguimentos...'
      try {
        this.gradeLevelGroups = await this.$api.getGradeLevelGroupsOfTeachingSystem(this.id)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter cursos, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    async getTeachingSystem () {
      this.loading = true
      this.loadingMsg = 'Carregando lista de curso/ano...'
      try {
        const response = await this.$api.getTeachingSystemID(this.id)
        this.teachingSystem = response
        this.currentTeachingSystem = utils.currentData(response)
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter cursos, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    checkUpdate () {
      const data = utils.newData(this.teachingSystem, this.currentTeachingSystem)
      if (utils.size(data) > 0) {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
      return data
    },
    sizes (data) {
      return utils.size(data)
    },
    async deleteTeachingSystem () {
      this.$dialog.confirm('Apagar sistema de ensno?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.request = true
          try {
            await this.$api.deleteTeachingSystem(this.id)
            this.request = false
            this.$store.dispatch('setSnackBar', { text: 'sistema de ensino excluido com sucesso.' })
            this.$router.replace({ name: 'sistema-de-ensino' })
          } catch {
            this.request = false
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },
    async updateTeachingSystem () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      this.request = true
      const data = this.checkUpdate()
      try {
        await this.$api.updateTeachingSystem(this.id, data)
        this.request = false
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
        this.fetchAll()
      } catch {
        this.request = false
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    },
    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>
